export const reMeasurementUnitConvertationConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_MEASUREMENT_UNIT_CONVERTATION_SUCCESS',
		REQUEST : 'GET_PAGED_MEASUREMENT_UNIT_CONVERTATION_REQUEST',
		FAILURE : 'GET_PAGED_MEASUREMENT_UNIT_CONVERTATION_FAILURE'
	},
	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_MEASUREMENT_UNIT_CONVERTATION_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_MEASUREMENT_UNIT_CONVERTATION_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_MEASUREMENT_UNIT_CONVERTATION_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_MEASUREMENT_UNIT_CONVERTATION_REQUEST',
		SUCCESS : 'CREATE_MEASUREMENT_UNIT_CONVERTATION_SUCCESS',
		FAILURE : 'CREATE_MEASUREMENT_UNIT_CONVERTATION_FAILURE'
	},
	Remove: {
		REQUEST : 'REMOVE_MEASUREMENT_UNIT_CONVERTATION_REQUEST',
		SUCCESS : 'REMOVE_MEASUREMENT_UNIT_CONVERTATION_SUCCESS',
		FAILURE : 'REMOVE_MEASUREMENT_UNIT_CONVERTATION_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_MEASUREMENT_UNIT_CONVERTATION_REQUEST',
		SUCCESS : 'UPDATE_MEASUREMENT_UNIT_CONVERTATION_SUCCESS',
		FAILURE : 'UPDATE_MEASUREMENT_UNIT_CONVERTATION_FAILURE'
	},
	CLEAR: 'CLEAR_MEASUREMENT_UNIT_CONVERTATION'
}